"use client";

import { createContext, useContext } from "react";
import { getVideoEmbedUrl } from "@/lib/utils";
import { useGetVideo } from "@/features/storage/sheets/hooks/useGetVideo";

// Set only in the public viewer: anonymous viewers can't call the auth-only video endpoint.
export const PublicPullZoneContext = createContext<string | null | undefined>(
    undefined
);

export const useStorageVideoEmbed = (videoId: string, enabled: boolean) => {
    const publicPullZone = useContext(PublicPullZoneContext);
    const isPublicView = publicPullZone !== undefined;
    const videoQuery = useGetVideo(enabled && !isPublicView, videoId);

    if (isPublicView) {
        return {
            isPending: false,
            embedUrl: publicPullZone
                ? getVideoEmbedUrl(publicPullZone, videoId)
                : null,
        };
    }

    const pullZone = videoQuery.data?.data.pullZone;
    return {
        isPending: videoQuery.isPending,
        embedUrl: pullZone ? getVideoEmbedUrl(pullZone, videoId) : null,
    };
};
